import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import pl from './locales/pl.json'
import en from './locales/en.json'

const resources = {
  pl,
  en
}

i18n.use(initReactI18next).init({
  resources,
  debug: false,
  lng: 'pl', // Default language, will be updated by app settings
  fallbackLng: 'pl',
  interpolation: {
    escapeValue: false
  }
})

export default i18n
